import { render } from "./CheckboxElement.vue?vue&type=template&id=2381610e&scoped=true"
import script from "./CheckboxElement.vue?vue&type=script&lang=js"
export * from "./CheckboxElement.vue?vue&type=script&lang=js"

import "./CheckboxElement.vue?vue&type=style&index=0&id=2381610e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2381610e"]])

export default __exports__